module.exports = __webpack_public_path__ + "static/media/AK_6.dcd697d0.jpeg";